// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Checkbox from 'material-ui/Checkbox'


class ChildProfile extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      customer:{
        "child_name": '',
        "child_dob": moment(),
        "child_gender": '',
        "child_game_type": '',
      }
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
  }

  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.customer);
    new_selected_one['child_dob'] = date
    this.setState({customer: new_selected_one});
  }

  componentDidMount() {
   
  }
  
  

  postEditedMatch(data, props) {
    console.log(data.date_of_birth);
    if(!data.child_dob){
      var date = undefined;
    }
    else{
      var date = moment(data.child_dob).format("YYYY-MM-DD");
    }
    const url = `${getLocationOrigin()}/customer_list/create_child_profile/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'customer_id': this.state.id,
                                      'child_name': data.child_name,
                                        'child_dob': date,
                                        'child_gender': data.child_gender,
                                        'child_game_type': data.child_game_type });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){
        alert(response.message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }


  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.customer);
    new_selected_one[name] = event.target.value
    this.setState({customer: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postEditedMatch(this.state.customer, this.props);
  }

  render() {
    console.log("here");
    console.log(this.state.customer.date_of_birth);
    return(
      <div style={styles.container}>
        <div className="row col-md-10 table-bordered" style={styles.table}>
            
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add New Kid Profile</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Name
              </div>
              <div className="col-md-6 input-group">
                <input type="text" name="child_name" className="form-control"
                  placeholder="Name" value={this.state.customer.child_name} onChange={this.handleChange}/>
              </div>
            </div>

               <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Date of Birth
              </div>
              <DatePicker selected={this.state.customer.child_dob} onChange={this.handleStartDate}/>
            </div>
    

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Gender
              </div>
              <select name="child_gender" className="col-md-6" style={styles.item_body} 
                onChange={this.handleChange}>
                  <option>Select Gender</option>
                  <option value="M">M</option>
                  <option value="F">F</option>
              }
              </select>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer GameType
              </div>
              <select name="child_game_type" className="col-md-6" style={styles.item_body} 
                onChange={this.handleChange}>
                  <option>Select Gametype</option>
                  <option value={8}>Football Academy</option>
                  <option value={10}>Badminton Academy</option>
              }
              </select>
            </div>
           
           
            
            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
         
         

        </div>
      </div>
    );
  }
}

export default ChildProfile;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/childProfile/index.js